import { render, staticRenderFns } from "./indexv2.vue?vue&type=template&id=8a8688d2"
import script from "./indexv2.vue?vue&type=script&lang=js"
export * from "./indexv2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports